import { Guid, ITranslations } from "@/types"
import ProductHierarchyProductModel, { IGetProductHierarchyProductModelDto } from "./ProductHierarchyProductModel"

export interface IGetProductHierarchyProductFamilyDto {
    id: Guid
    description: string
    descriptionTranslations: ITranslations
    modelCount: number
    models: IGetProductHierarchyProductModelDto[]
}

export default class ProductHierarchyProductFamily {
    id: Guid
    description: string
    descriptionTranslations: ITranslations
    modelCount: number
    models: ProductHierarchyProductModel[]

    constructor(dto: IGetProductHierarchyProductFamilyDto) {
        this.id = dto.id
        this.description = dto.description
        this.descriptionTranslations = dto.descriptionTranslations
        this.modelCount = dto.modelCount
        this.models = dto.models.map(m => new ProductHierarchyProductModel(m))
    }

    get hasArticles() {
        return this.models.some(m => m.hasArticles)
    }
}
